import { useGetSupportedValuesQuery } from "./supportedValuesApi";
import { useMemo } from "react";

export const useSupportedValues = (property) => {
  const { data, isFetching } = useGetSupportedValuesQuery();

  const options = useMemo(
    () =>
      (data?.[property] || []).map((locale) => ({
        value: locale,
        label: locale,
      })),
    [data]
  );

  return { options, isFetching };
};
